export function convertInchesToMeters(inches: number) {
  const ratio = 0.0254;

  return inches * ratio;
}
